import ComponentPanel from "./ComponentPanel.js";
import * as DomBuilder from "./dom-builder.js";
import Filters from "../Filters.js";
import { EditorView, basicSetup } from "codemirror"
import { json } from "@codemirror/lang-json"

/**
 *
 * @version 2026-09-03
 * @author Patrik Harag
 */
export default class ComponentPanelFilters extends ComponentPanel {

    /** @type {Controller} */
    #controller;

    /** @type {EditorView} */
    #editor;

    /**
     *
     * @param controller {Controller}
     */
    constructor(controller) {
        super();
        this.#controller = controller;

        controller.getDataManager().addOnRawFiltersFetched(json => {
            this.#setRawData(json);
        });
    }

    getTabId() {
        return 'finance-tab-filters';
    }

    getTabName() {
        return [
            DomBuilder.element("i", { class: "fa fa-cog" }),
            DomBuilder.span(" Filters")
        ];
    }

    createNode() {
        this.#editor = new EditorView({
            extensions: [basicSetup, json()],
        })

        return DomBuilder.div({ class: 'panel-filters' }, [
            this._createHelp(),
            DomBuilder.par(null, "Filter definitions:"),
            DomBuilder.div(null, [
                this.#editor.dom,
                DomBuilder.button('Update', { class: 'btn btn-primary' }, e => {
                    this.#controller.getDataManager().updateFilters(this.#getRawData(), true, true);
                })
            ])
        ]);
    }

    _createHelp() {
        function asCode(str) {
            return '<code>' + str + '</code>';
        }

        return DomBuilder.bootstrapAlert('alert-info', [
            DomBuilder.create(`<p><strong>Filter</strong> is a way how to define a category of transactions.</p>`),
            "Filter definition:",
            DomBuilder.create(`<ul>
                <li><code>name</code> (string)</li>
                <li><code>color</code> (string) [optional] &#8211; label CSS color</li>
                <li><code>query</code> (object) [optional, matches all if not set]
                    <br>
                    <strong>Query:</strong>
                    <ul>
                        <li>The syntax is inspired by MongoDB queries.</li>
                        <li>Fields: ${ Filters.QUERY_FIELDS.map(asCode).join(', ') }. Default: <code>description</code>.</li>
                        <li>Operators: ${ Filters.QUERY_OPERATORS.map(asCode).join(', ') }. Default: <code>$contains</code> (string) / <code>$eq</code> (number).</li>
                    </ul>
                </li>
                <li><code>hideInTable</code> (boolean) [optional, default = false] &#8211; hide this filter in tables (for very generic, negated or overlapping filters)</li>
            </ul>`)
        ]);
    }

    #setRawData(data) {
        this.#editor.dispatch({
            changes: {from: 0, to: this.#editor.state.doc.length, insert: data}
        });
    }

    #getRawData() {
        return this.#editor.state.doc.toString();
    }
}
